import { Component, Input, OnInit } from '@angular/core';
import { IconColor, IconSize } from './svg-icon.types';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'svg-icon',
  imports: [],
  templateUrl: './svg-icon.component.html',
  styleUrl: './svg-icon.component.scss',
})
export class SvgIconComponent implements OnInit {
  iconStyle?: string;

  @Input() size: IconSize = 'medium';
  @Input() color?: IconColor;

  @Input()
  set icon(id: string) {
    this.href = `icons.svg#${id}`;
  }
  href = '';

  ngOnInit(): void {
    this.iconStyle = `icon icon--${this.size}`;
    if (this.color) {
      this.iconStyle = `icon icon--${this.size} icon--${this.color}`;
    }
  }
}
